import React from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { ShieldAlertIcon, ShieldCheckIcon, AlertTriangleIcon, SearchIcon } from 'lucide-react';
const riskTasks = [{
  id: 'RT-001',
  supplier: 'CleanPro Services',
  domain: 'Financial',
  issue: 'Credit rating downgrade',
  priority: 'High',
  status: 'Open'
}, {
  id: 'RT-002',
  supplier: 'RetailFit Solutions',
  domain: 'ESG',
  issue: 'Missing sustainability report',
  priority: 'Medium',
  status: 'In Progress'
}, {
  id: 'RT-003',
  supplier: 'Global Foods Ltd',
  domain: 'Sanctions',
  issue: 'Potential adverse media match',
  priority: 'Critical',
  status: 'Open'
}];
export const RiskWorkbenchPage: React.FC = () => {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-567">
      <PageHeader title="Risk Workbench" description="Monitor supplier risk alerts and compliance status." primaryAction={<Button data-id="element-569">Initiate Assessment</Button>} data-id="element-568" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-570">
        <KPICard title="High/Critical Risk" value="2" icon={<ShieldAlertIcon className="w-5 h-5 text-status-error" data-id="element-572" />} data-id="element-571" />
        <KPICard title="Medium Risk" value="4" icon={<AlertTriangleIcon className="w-5 h-5 text-status-warning" data-id="element-574" />} data-id="element-573" />
        <KPICard title="Under Review" value="1" icon={<SearchIcon className="w-5 h-5 text-status-info" data-id="element-576" />} data-id="element-575" />
        <KPICard title="Policy Exceptions" value="1" icon={<ShieldCheckIcon className="w-5 h-5 text-text-secondary" data-id="element-578" />} data-id="element-577" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-579">
        <div className="lg:col-span-2 space-y-6" data-id="element-580">
          <Card data-id="element-581">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-582">
              Risk Heatmap (Top Suppliers)
            </h2>
            <div className="overflow-x-auto" data-id="element-583">
              <table className="w-full text-sm text-left border-collapse" data-id="element-584">
                <thead data-id="element-585">
                  <tr className="border-b border-border-light" data-id="element-586">
                    <th className="p-2 font-medium" data-id="element-587">Supplier</th>
                    <th className="p-2 font-medium text-center" data-id="element-588">Financial</th>
                    <th className="p-2 font-medium text-center" data-id="element-589">Legal</th>
                    <th className="p-2 font-medium text-center" data-id="element-590">ESG</th>
                    <th className="p-2 font-medium text-center" data-id="element-591">Security</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border-light" data-id="element-592">
                  <tr data-id="element-593">
                    <td className="p-2 font-medium" data-id="element-594">CleanPro Services</td>
                    <td className="p-2" data-id="element-595">
                      <div className="w-full h-6 bg-status-error rounded-sm" data-id="element-596"></div>
                    </td>
                    <td className="p-2" data-id="element-597">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-598"></div>
                    </td>
                    <td className="p-2" data-id="element-599">
                      <div className="w-full h-6 bg-status-warning rounded-sm" data-id="element-600"></div>
                    </td>
                    <td className="p-2" data-id="element-601">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-602"></div>
                    </td>
                  </tr>
                  <tr data-id="element-603">
                    <td className="p-2 font-medium" data-id="element-604">RetailFit Solutions</td>
                    <td className="p-2" data-id="element-605">
                      <div className="w-full h-6 bg-status-warning rounded-sm" data-id="element-606"></div>
                    </td>
                    <td className="p-2" data-id="element-607">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-608"></div>
                    </td>
                    <td className="p-2" data-id="element-609">
                      <div className="w-full h-6 bg-status-error rounded-sm" data-id="element-610"></div>
                    </td>
                    <td className="p-2" data-id="element-611">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-612"></div>
                    </td>
                  </tr>
                  <tr data-id="element-613">
                    <td className="p-2 font-medium" data-id="element-614">Oceanic Harvest Pte Ltd</td>
                    <td className="p-2" data-id="element-615">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-616"></div>
                    </td>
                    <td className="p-2" data-id="element-617">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-618"></div>
                    </td>
                    <td className="p-2" data-id="element-619">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-620"></div>
                    </td>
                    <td className="p-2" data-id="element-621">
                      <div className="w-full h-6 bg-status-success rounded-sm" data-id="element-622"></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>

          <Card data-id="element-623">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-624">
              Remediation Tasks
            </h2>
            <DataTable data={riskTasks} columns={[{
            header: 'Supplier',
            accessorKey: 'supplier',
            cell: row => <span className="font-medium" data-id="element-626">{row.supplier}</span>
          }, {
            header: 'Domain',
            accessorKey: 'domain'
          }, {
            header: 'Issue',
            accessorKey: 'issue'
          }, {
            header: 'Priority',
            cell: row => <span className={`font-medium ${row.priority === 'Critical' || row.priority === 'High' ? 'text-status-error' : 'text-status-warning'}`} data-id="element-627">
                      {row.priority}
                    </span>
          }, {
            header: 'Status',
            cell: row => <StatusPill status={row.status} data-id="element-628" />
          }]} data-id="element-625" />
          </Card>
        </div>

        <div className="space-y-6" data-id="element-629">
          <Card data-id="element-630">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-631">
              External Screening
            </h2>
            <div className="space-y-4" data-id="element-632">
              <div className="p-3 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-633">
                <div className="flex justify-between items-center mb-2" data-id="element-634">
                  <h3 className="font-medium text-text-primary" data-id="element-635">
                    Dow Jones Risk & Compliance
                  </h3>
                  <StatusPill status="Active" data-id="element-636" />
                </div>
                <p className="text-sm text-text-secondary" data-id="element-637">
                  Continuous screening enabled for 487 active suppliers.
                </p>
                <p className="text-xs text-text-tertiary mt-2" data-id="element-638">
                  Last sync: 1 hour ago
                </p>
              </div>
              <div className="p-3 border border-border-light rounded-fluent bg-surface-secondary" data-id="element-639">
                <div className="flex justify-between items-center mb-2" data-id="element-640">
                  <h3 className="font-medium text-text-primary" data-id="element-641">
                    Ecovadis ESG
                  </h3>
                  <StatusPill status="Active" data-id="element-642" />
                </div>
                <p className="text-sm text-text-secondary" data-id="element-643">
                  API integration active. 142 scorecards retrieved.
                </p>
                <p className="text-xs text-text-tertiary mt-2" data-id="element-644">
                  Last sync: 1 day ago
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};